// extracted by mini-css-extract-plugin
export default {"level":"Level_level__dTUv+","levelSmall":"Level_levelSmall__uNgXZ"};